export default "__VITE_PUBLIC_ASSET__daafbef7__"